interface Props {
  label: string;
  active?: boolean;
  onClick: () => void;
}

const POSPaymentMethodButton: React.FC<Props> = ({
  label,
  active,
  onClick,
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`
        rounded-xl
        border

        px-3
        py-3

        text-sm
        font-medium

        transition-all
        duration-200

        ${
          active
            ? `
              border-primary
              bg-primary

              text-white

              shadow-1
            `
            : `
              border-stroke
              bg-white

              text-black

              hover:border-primary
              hover:bg-gray
              hover:text-primary

              dark:border-strokedark
              dark:bg-meta-4
              dark:text-white

              dark:hover:border-primary
              dark:hover:bg-graydark
            `
        }
      `}
    >
      {label}
    </button>
  );
};

export default POSPaymentMethodButton;
